import {default as throttle} from "lodash/throttle"

export class ScrollTransitions {
  static selector = "[data-scroll-transition]"

  constructor(els) {
    this.els = Array.from(els)

    // if user has expressed a preference for reduced motion, do not do animated transitions
    const matchReducedMotion = window.matchMedia?.(`(prefers-reduced-motion: reduce)`)
    if (matchReducedMotion && (matchReducedMotion === true || matchReducedMotion.matches === true)) {
      return;
    }

    if (this.els.length) {
      this.setup()
    }
  }

  onScroll = _ev => {
    const scrollYtop = window.scrollY, scrollYbot = scrollYtop + window.innerHeight, toRemove = []

    this.els.forEach(el => {
      // client rects are relative to viewport, we want element Y relative to document
      const elTop = el.getBoundingClientRect().top + scrollYtop
      if (elTop <= scrollYbot) {
        const className = `${el.dataset.scrollTransition}--visible`
        el.classList.add(className)
        toRemove.push(el)
      }
    })

    this.els = this.els.filter(el => !toRemove.includes(el))

    if (!this.els.length) {
      document.removeEventListener("scroll", this.onScrollThrottle)
    }
  }

  setup = () => {
    this.els.forEach(el => {
      const className = el.dataset.scrollTransition
      if (!className) {
        throw new Error(`Invalid data-scroll-transition=${className} on element`)
      }
      el.classList.add(className)
    })

    this.onScroll()
    this.onScrollThrottle = throttle(this.onScroll, 100, {leading: true, trailing: true})
    document.addEventListener("scroll", this.onScrollThrottle)
  }
}
